/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, names: NonNullable<unknown> }} Project_Broken_Links_DescriptionInputs */



/**
* | output |
* | --- |
* | "{count} linked source(s) can no longer be reached: {names}. Nobody in this project still has access to them — the member who linked them left, lost access, o..." |
*
* @param {Project_Broken_Links_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_broken_links_description = /** @type {((inputs: Project_Broken_Links_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Broken_Links_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} verknüpfte Quelle(n) sind nicht mehr erreichbar: ${i?.names}. Niemand in diesem Projekt hat noch Zugriff darauf — das Mitglied, das sie verknüpft hat, hat das Projekt verlassen, den Zugriff verloren oder sein Konto wurde gelöscht. KI-Antworten in diesem Projekt nutzen sie daher nicht.`)
	return /** @type {LocalizedString} */ (`${i?.count} linked source(s) can no longer be reached: ${i?.names}. Nobody in this project still has access to them — the member who linked them left, lost access, or their account was deleted — so AI responses in this project will not use them.`)
});